/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import { mapGetters } from 'vuex';
import productGroupService from './../../../../services/product-group';
import productGroupTransformer from './../../../../transformers/productGroup';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';
import exciseGroupService from './../../../../services/exciseGroup';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        parentGroupId: {
          value: '',
          type: 'select',
        },
        exciseDutyId: {
          value: '',
          type: 'select',
        },
      }),
      loading: false,
    };
  },

  created() {
    Promise.all([
      productGroupService.all(),
      exciseGroupService.all(),
    ]).then(() => {
      this.loading = false;
    });
    this.show();
  },

  computed: {
    ...mapGetters({
      productGroups: 'allProductGroups',
      // duties: 'allExciseDuties',
    }),
  },

  methods: {
    /**
     * Method to update the product group.
     */
    update() {
      this.form.loading = true;
      const productGroup = productGroupTransformer.send(this.form.data());
      productGroupService.update(store.state.route.params.id, productGroup)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.productGroups.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'productGroups.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      productGroupService.show(store.state.route.params.id).then((productGroup) => {
        this.form.assignData(productGroup);
        this.loading = false;
      });
    },
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} productGroups The product groups list.
     */
    /* eslint max-len: ["error", 150] */
    productGroups(productGroups) {
      this.form.setOptions('parentGroupId', productGroups.all);
    },

    duties(duties) {
      console.log(duties);
      this.form.setOptions('exciseDutyId', duties.map(c => (
              { id: c.id, name:`${c.title }` }
      )));
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productGroups/edit/edit.js